import { get, push, ref, update } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetCustomersData from "../../Comman/GetCustomersData";
import { Currency } from "lucide-react";

const EditCustomerData = async (state, dispatch, customerData, userId) => {

  const USERID = userId ? userId : state?.USERID;

  console.log("userid", USERID);

  if (!USERID) return null;

  try {
    const customerRef = ref(database, `invoiceGenerator/users/${USERID}/customers`);
    const snapshot = await get(customerRef);
    const existingCustomers = snapshot.val();

    let isCustomerExist = false;
    let existingCustomerKey = null;
    let existingCustomerData = null;

    if (existingCustomers) {
      Object.entries(existingCustomers).forEach(([key, customer]) => {
        if (customer.customer?.toLowerCase() === customerData.customer?.toLowerCase()) {
          isCustomerExist = true;
          existingCustomerKey = key;
          existingCustomerData = customer;
        }
      });
    }

    const actorName = state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest";

    if (!isCustomerExist) {
      // create new customer
      const cleanedCustomer = {
        ...customerData,
        createdBy: actorName,
        createdById: state?.USERID || null,
        updatedBy: actorName,
        updatedById: state?.USERID || null,
        customerId: Math.floor(new Date().getTime()),
        createdAt: Date.now().toString(),
        updatedAt: Date.now().toString(),
        invoiceCount: 1,
        currency: customerData?.currency,
        //invoices: [customerData.invoices?.[0] || ""], // add first invoice
        totalPaid: 0,
      };
      await push(customerRef, cleanedCustomer);
    } else {
      // update existing customer
      const itemUpdateRef = ref(
        database,
        `invoiceGenerator/users/${USERID}/customers/${existingCustomerKey}`
      );

      // ✅ Handle invoice appending
      let invoices = existingCustomerData.invoices || [];
      const newInvoiceId = customerData?.invoices?.[0];

      if (newInvoiceId && !invoices.includes(newInvoiceId)) {
        invoices.push(newInvoiceId);
      }

      const updates = {
        ...existingCustomerData,
        updatedBy: actorName,
        phone: customerData?.phone,
        email: customerData?.email,
        address: customerData?.address,
        dialCode: customerData?.dialCode || customerData?.dial_code,
        customerGSTNo: customerData?.customerGSTNo,
        updatedAt: Date.now().toString(),
        invoices, // updated invoices list
        invoiceCount: invoices.length,
        totalAmount: customerData?.totalAmount ?? "0",
        currency: customerData?.currency || existingCustomerData?.currency || "",
        // country: customerData?.country || existingCustomerData?.country || "",
        // countryCode: customerData?.countryCode || existingCustomerData?.countryCode || "",
      };
      await update(itemUpdateRef, updates);
    }

    await GetCustomersData(state, dispatch);
  } catch (error) {
    console.error("Error in EditCustomerData:", error);
    return null;
  }
};

export default EditCustomerData;
